
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

/**
 *  Base class for every input component, holding all shared input logic.
 */
@Component
export default class InputBase<Value = string> extends Vue {

    @Prop({ type: String, required: true })
    protected name!: string;

    @Prop({ required: true })
    protected value!: Value;

    @Prop({ type: String })
    protected placeholder!: string;

    @Prop({ type: Boolean })
    protected disabled!: boolean;

    @Prop({ type: Number })
    protected maxlength!: number;

    /**
     *
     *  Keep, use and sync an internal value to ensure new
     *  values get reflected by the components on update.
     *
     *  (i) Ensuring the internal value is updated when
     *  the original value is updated
     *
     */
    protected newValue: Value | null = null;

    @Watch('value', { immediate: true })
    private onUpdate(value: Value | null): void {

        this.newValue = value;

    }

    /**
     *
     *  Methods to emit the events.
     *
     *  (i) Not using a model getter/setter because sometimes
     *  we must emit another or transformed value.
     *
     *  E.g: `$event.target.valueAsNumber` for the number input
     *
     */
    protected onInput(value: Value | null): void {

        this.$emit('input', value);
        this.$emit('update', value);

    }

    protected onBlur(value: Value): void {

        this.newValue = value;

        this.$emit('blur', value);

    }

    /**
     *
     *  Used to emit a custom event: it's propagated to the
     *  FormInputComponent, which on his turn emits the actual
     *  event (name) and payload.
     *
     *  @param event The name of the event to emit
     *  @param payload The payload to emit for the event
     *
     */
    protected emitCustomEvent(event: string, payload?: unknown): void {

        this.$emit('custom-event', { event, payload });

    }

}
